import type { Route } from '@angular/router';
import {
  hasStringPathParamCanActivateGuard,
  sequentialDeactivateGuards,
} from '@pct-ng/core/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';

export const poiRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/poi-list.component').then(({ PoiListComponent }) => PoiListComponent),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/poi-details.component').then(
        ({ PoiDetailsComponent }) => PoiDetailsComponent,
      ),
    title: 'PAGES.POI.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.POI.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/poi-details.component').then(
        ({ PoiDetailsComponent }) => PoiDetailsComponent,
      ),
    title: 'PAGES.POI.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.POI.SINGULAR'),
      ]),
    ],
  },
];
